module.exports = __webpack_public_path__ + "static/media/builder.826ba04b.png";